import Client from '@/repositories/Clients/AxiosClient'
import Config from '@/repositories/Clients/AxiosDefaultConfig'

const resource = `${Config.basePath}/customer`

export default {
  updateCustomerProfile(id, payload) {
    return Client.put(`${resource}/${id}`, {
      ...payload,
    })
  },
}
